// extracted by mini-css-extract-plugin
export default {"emptyBlock":"NoOptions_emptyBlock__GtnA3"};